import { CountryRegionData } from "react-country-region-selector";

// Country codes pinned to the top of every country dropdown, in this order.
// All current dealers are in the US, so it goes first; the rest stay alphabetical.
export const PRIORITY_COUNTRY_CODES = ["US"];

export const CountryRegionDataUSFirst = [
  ...PRIORITY_COUNTRY_CODES.map((code) =>
    CountryRegionData.find((country) => country[1] === code)
  ).filter(Boolean),
  ...CountryRegionData.filter(
    (country) => !PRIORITY_COUNTRY_CODES.includes(country[1])
  ),
];
